/**
 * 积分用户接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PointsUserService {
   //基础平台微服务api
   prefix: string = environment.smsWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region 
  /**
   * 会员积分分页查询
   */
  queryPoints(param) {
    const url = this.prefix + 'backend/queryPointsPage';
    return this.http.Post(url, param);
  }

    //#region 
  /**
   * 积分冻结分页查询
   */
  queryFrozenPage(param) {
    const url = this.prefix + 'backend/queryFrozenPage';
    return this.http.Post(url, param);
  }

      //#region 
  /**
   * 积分记录分页查询
   */
  queryRecordPage(param) {
    const url = this.prefix + 'backend/queryRecordPage';
    return this.http.Post(url, param);
  }

        //#region 
  /**
   * 会员积分手动结算
   */
  updateSettlement(param) {
    const url = this.prefix + 'backend/updateSettlement';
    return this.http.Post(url, param);
  }

          //#region 
  /**
   * 修改会员积分账户锁定状态
   */
  updatePointsLock(param) {
    const url = this.prefix + 'backend/updatePointsLock';
    return this.http.Post(url, param);
  }

  
          //#region 
  /**
   * 积分统计分页查询
   */
  queryStatisticsPage(param) {
    const url = this.prefix + 'backend/queryStatisticsPage';
    return this.http.Post(url, param);
  }

          //#region 
  /**
   * 执行月统计
   */
  settlementMonth(param) {
    const url = this.prefix + 'backend/settlementMonth?'+param;
    return this.http.Get(url);
  }

            //#region 
  /**
   * 执行年统计
   */
  settlementYear(param) {
    const url = this.prefix + 'backend/settlementYear?'+param;
    return this.http.Get(url);
  }

              //#region 
  /**
   * 积分跟踪分页查询
   */
  queryTracePage(param) {
    const url = this.prefix + 'backend/queryTracePage';
    return this.http.Post(url, param);
  }

              //#region 
  /**
   * 积分跟踪处理
   */
  handleTrace(param) {
    const url = this.prefix + 'backend/handleTrace';
    return this.http.Post(url, param);
  }

                //#region 
  /**
   * 删除积分跟踪
   */
  deleteTrace(param) {
    const url = this.prefix + 'backend/deleteTrace';
    return this.http.Post(url, param);
  }
}
